import axios from "../http_v2";

export default {
  // 获取视频列表
  list(params) {
    return axios.get("activityservice/video/list", params);
  },
  // 保存视频信息到MK
  save(params) {
    return axios.post("activityservice/video/save", params);
  },
  // 更新视频封面
  videoCover(params) {
    return axios.post("videoservice/video/UpdateVideoInfo", params);
  },
  // 保存视频信息到盟主
  saveMengzhu(params) {
    return axios.get("activityservice/video/createUploadVideo", params);
  },
  // 删除MK视频信息
  delete(params) {
    return axios.get("activityservice/video/delete", params);
  },
  // 删除阿里云视频信息 ----待定
  deleteAliyun(params) {
    return axios.get("videoservice/video/deleteVideoResponse", params);
  },
  // 获取阿里云视频上传凭证
  getVideoUploadAuth(params) {
    return axios.get("videoservice/video/uploadAuth", params);
  },
  // 刷新阿里云视频上传凭证
  refreshVideoUploadAuth(params) {
    return axios.get("videoservice/video/refreshUploadVideo", params);
  },
  // 获取盟主视频上传凭证
  getVideoTokenMengzhu(params) {
    return axios.get("activityservice/video/uploadToken", params);
  },
  type: {
    // 视频分类树
    tree(params) {
      return axios.get("activityservice/videoTree/get/tree", params);
    },
    // 视频分类树添加和编辑分类
    save(params) {
      return axios.post("activityservice/videoTree/save", params);
    },
    // 删除分类
    delete(params) {
      return axios.get(
        "activityservice/videoTree/delete/id?id=" + params.id,
        {}
      );
    },

  },
  // 搜索中的视频列表--他人分享
  topic(params) {
    return axios.get("activityservice/video/list/for/topic", params);
  },
};
